<template>
  <group class="second_sel">
      <cell :title="storeName">
        <span slot="after-title" class="sel_title" v-if="customFlag">|&nbsp;&nbsp;{{customFlag}}</span>
        <span slot="after-title" class="sel_title" v-else>|&nbsp;&nbsp;{{flag}}</span>
        <button slot="child" class="second_sel_list" v-for="(item, index) in selList" :key="index" :class="{'btn_sel': flag === item.key}" @click.stop="selectTab(item.key)">{{item.name}}</button>
      </cell>
    </group>
</template>
<script>
import { Group, Cell } from '@lx-frontend/cvux'
export default {
  components: { Group, Cell },
  props: {
    storeName: {
      type: [String, Number],
      default: '统计时间'
    },
    customFlag: {
      type: [String, Number],
      default: ''
    },
    flag: {
      type: [String, Number],
      default: ''
    },
    selList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    selectTab(key) {
      if (this.flag === key) return false
      this.$emit('update:flag', key)
      this.$emit('select-tab')
    }
  }
}

</script>
<style lang="less">
@import "../../../stylesheets/modules/data/secondSel.less";
</style>
